import { render, staticRenderFns } from "./AddCommunityButton.vue?vue&type=template&id=70088d6e&scoped=true&"
import script from "./AddCommunityButton.vue?vue&type=script&lang=js&"
export * from "./AddCommunityButton.vue?vue&type=script&lang=js&"
import style0 from "./AddCommunityButton.vue?vue&type=style&index=0&id=70088d6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70088d6e",
  null
  
)

export default component.exports